import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=63ec974a"
import script from "./OrderFilters.vue?vue&type=script&lang=js"
export * from "./OrderFilters.vue?vue&type=script&lang=js"
import style0 from "./OrderFilters.vue?vue&type=style&index=0&id=63ec974a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports